import { render, staticRenderFns } from "./FilmSchedule.vue?vue&type=template&id=2fc22c80&scoped=true"
import script from "./FilmSchedule.vue?vue&type=script&lang=js"
export * from "./FilmSchedule.vue?vue&type=script&lang=js"
import style0 from "./FilmSchedule.vue?vue&type=style&index=0&id=2fc22c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc22c80",
  null
  
)

export default component.exports